// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-reorder-payment[data-v-053bd4c3]{padding-top:60px}", ""]);
// Exports
module.exports = exports;
